
import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const About = () => {

   useEffect(() => {
    // Scroll to the banner section on page load
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <div>
      <section className="banner1">
        <div className="banner-overlay1"></div>
        <div className="banner-content">
          <h6 className="banner-subtitle">Home / About Us</h6>
          <hr />
          <h1 className="banner-title" style={{ fontSize: "60px" }}>
            Who We Are
          </h1>

          {/* <p>Leverage cutting-edge software and analytics to improve patient outcomes and operational efficiency in healthcare.</p>

          <button className="banner-button mt-3">
            Let’s talk <span className="arrow">→</span>
          </button> */}
        </div>

        {/* Add the image element */}
        <img
          className="banner-image"
          src="https://img.freepik.com/free-photo/modern-equipped-computer-lab_23-2149241210.jpg"
          alt="Healthcare Solutions"
        />
      </section>

      <section id="about" className="about py-5">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <h6 className="col_yell">About Us</h6>
              <h2>Transforming Businesses with AI-Driven Data Solutions</h2>
              <p>
                DataFluent Analytics provides AI & ML based end-to-end data
                driven business solutions and services covering System
                Infrastructure, Rapid Application Development, Data Analytics
                and Cloud Integration based on relational and Big Data platforms
                in Multi-cloud and On-premise environments.
              </p>

              <p>
                Our solutions provide business improvement by implementing
                Machine Learning, Predictive Analytics and other cutting-edge
                technologies turning new technologies into real business value.
                Besides technology excellence, we have deep business expertise
                in Financial Services, Telco and Utility industries, and public
                sector, which we successfully use in enabling business agility
                of our clients.
              </p>
            </div>

            <div className="col-md-6">
              <div className="about_pg1r">
                <div className="grid clearfix">
                  <figure className="effect-jazz mb-0">
                    <a href="#">
                      <img
                        src="https://img.freepik.com/free-photo/modern-equipped-computer-lab_23-2149241210.jpg"
                        className="w-100"
                        alt="Empowering Decisions"
                      />
                    </a>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="services" class="services py-5 bg-black text-white">
        <div class="container">
          <div class="row">
            <div class="col-md-12 text-center">
              <h2>What We Do</h2>
              <p>
                We provide a wide range of software and analytics services to
                help businesses succeed in the digital world.
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <h4>Software Development Services</h4>
              <ul>
                <li>Custom Software Development</li>
                <li>Web Application Development</li>
                <li>Mobile Application Development</li>
                <li>SaaS Solutions</li>
                <li>System Integration</li>
                <li>UI/UX Design</li>
              </ul>
            </div>

            <div class="col-md-4">
              <h4>Data Analytics Services</h4>
              <ul>
                <li>Business Intelligence (BI)</li>
                <li>Big Data Analytics</li>
                <li>Predictive Analytics</li>
                <li>Data Visualization</li>
                <li>ETL (Extract, Transform, Load)</li>
              </ul>
            </div>

            <div class="col-md-4">
              <h4>AI & Machine Learning Solutions</h4>
              <ul>
                <li>Machine Learning Models</li>
                <li>Natural Language Processing (NLP)</li>
                <li>Computer Vision</li>
                <li>Recommendation Systems</li>
              </ul>
            </div>
          </div>

          <div class="row mt-4">
            <div class="col-md-4">
              <h4>Cloud Integration and Services</h4>
              <ul>
                <li>Cloud Migration</li>
                <li>Multi-cloud Management</li>
                <li>Cloud Security</li>
                <li>DevOps Services</li>
              </ul>
            </div>

            <div class="col-md-4">
              <h4>Industry-Specific Solutions</h4>
              <ul>
                <li>Financial Analytics</li>
                <li>Telecom Analytics</li>
                <li>Utility Management</li>
                <li>Public Sector Analytics</li>
              </ul>
            </div>

            <div class="col-md-4">
              <h4>Support and Maintenance</h4>
              <ul>
                <li>Technical Support</li>
                <li>Software Upgrades</li>
                <li>Performance Optimization</li>
              </ul>
            </div>
          </div>

          <div class="row mt-4">
            <div class="col-md-12">
              <h4>Training and Consulting</h4>
              <ul>
                <li>Data Analytics Training</li>
                <li>Software Consulting</li>
                <li>AI/ML Workshops</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section id="serv_h" className="p_3">
        <div className="container-xl">
          <div className="row serv_h3 mt-4  pt-5 pb-5 mx-0 px-4">
            <div className="col-md-8">
              <div className="serv_h3l">
                {/* <h6 className="">Benefits</h6> */}
                <h2 className="">Ready to Transform Your Data?</h2>
                <p className="mt-3">
                  Need data-driven solutions for your business? Get in touch
                  with us today
                </p>
                <button className="banner-button mt-3">
  <Link to="/contact" className="text-decoration-none text-white">
    Let’s talk <span className="arrow">→</span>
  </Link>
</button>
              </div>
            </div>
            <div className="col-md-4">
              <div className="serv_h3r">
                <div className="grid clearfix">
                  <figure className="effect-jazz mb-0">
                    <Link to="/contact">
                      <img
                        src="https://img.freepik.com/free-photo/medium-shot-two-colleagues-discussing-business-office_1098-17855.jpg"
                        className="w-100"
                        alt="Help"
                      />
                    </Link>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
